<template>
    <section class="monitoringServer">
        <simple-value :value="name" :status="3">Server</simple-value>
        <simple-value :value="statusName" :status="status">Status</simple-value>
        <simple-value :value="dateStart" :status="3">Start</simple-value>
        <simple-value :value="dateSince" :status="2">Since</simple-value>
        <simple-value :value="dateLive" :status="3">Live</simple-value>
        <simple-value :value="dbSource" :status="dbSourceStatus">DbSource</simple-value>
        <simple-value :value="dbExport" :status="dbExportStatus">DbExport</simple-value>
        <load-average />
        <gauge :data="cpu">Cpu</gauge>
        <gauge :data="memory">Mem</gauge>
        <gauge :data="usage">Usage</gauge>
        <gauge :data="swap">Swap</gauge>
        <label>Disk</label>
        <gauge is="gauge" v-for="disk in disks" :key="disk.name" :data="disk" />
        <network :isTitle="true" :data="{ name: 'Net', rx: 'Rx/s', tx: 'Tx/s' }" />
        <network is="network" v-for="network in networks" :key="network.name" :data="network" />
    </section>
</template>

<script>
import { bytes, percent, statusValue, timeLength } from '@/helpers/format'
import { createNamespacedHelpers } from 'vuex'
import SimpleValue from '@/components/monitoring/SimpleValue'
import LoadAverage from '@/components/monitoring/LoadAverage'
import Gauge from '@/components/monitoring/Gauge'
import Network from '@/components/monitoring/Network'

const { mapGetters } = createNamespacedHelpers('Server')

export default {
  data () {
    return {
      dateSince: ''
    }
  },
  components: { Gauge, LoadAverage, Network, SimpleValue },
  computed: {
    status () {
      const status = this.$store.getters['Server/status']
      return [1, 2, 0, 0][status]
    },
    statusName () {
      let message = ''
      switch (this.$store.getters['Server/status']) {
        case 0:
          message = 'Connecting'
          break
        case 1:
          message = 'Open'
          if (this.$store.getters['Server/connected'] === true) {
            message += ' - Connected: ' + this.$store.getters['Server/user']
          } else {
            message += ' - Not connected'
          }
          break
        case 2:
          message = 'Closing'
          break
        case 3:
          message = 'Closed - Restart in ' + this.$store.getters['Server/reconnect']
          break
      }
      return message
    },
    dateStart () { return this.$store.getters['Server/dateStart'] ? new Date(this.$store.getters['Server/dateStart']).toISOString() : '' },
    dateLive () { return this.$store.getters['Server/live'] ? this.$store.getters['Server/live'].toISOString() : '' },
    dbExport () { return this.$store.getters['Server/dbExport'] === true ? 'Connected' : 'Not connected' },
    dbSource () { return this.$store.getters['Server/dbSource'] === true ? 'Connected' : 'Not connected' },
    dbSourceStatus () { return this.$store.getters['Server/dbSource'] === true ? 2 : 0 },
    dbExportStatus () { return this.$store.getters['Server/dbExport'] === true ? 2 : 0 },
    ...mapGetters([
      'name'
    ]),
    cpu () {
      const cpu = this.$store.getters['Monitoring/cpu']
      return this.translate('Cpu', cpu.cores + ' cores', cpu.total, cpu.used)
    },
    memory () {
      const mem = this.$store.getters['Monitoring/memory']
      return this.translate('Mem', this.bytes(mem.used) + 'B', mem.total, mem.used)
    },
    usage () {
      const usage = this.$store.getters['Monitoring/usage']
      return this.translate('Usage', this.bytes(usage.used) + 'B', usage.total, usage.used)
    },
    swap () {
      const swap = this.$store.getters['Monitoring/swap']
      return this.translate('Swap', this.bytes(swap.total) + 'B', swap.total, swap.used)
    },
    disks () {
      const items = []
      const disks = this.$store.getters['Monitoring/disks']
      for (let i = 0; i < disks.length; i++) {
        items.push(this.translate(disks[i].name, this.bytes(disks[i].total) + 'B', disks[i].total, disks[i].used))
      }
      return items
    },
    networks () {
      const items = []
      const nets = this.$store.getters['Monitoring/nets']
      for (let i = 0; i < nets.length; i++) {
        items.push({ name: nets[i].name, rx: this.bytes(nets[i].rx) + 'b', tx: this.bytes(nets[i].tx) + 'b' })
      }
      return items
    }
  },
  methods: {
    stopWatch () {
      const self = this
      setInterval(function () {
        if (self.dateStart) {
          self.dateSince = self.formatDate(new Date(self.dateStart))
        }
      }, 1000)
    },
    formatDate (start, end) {
      return timeLength(start, end)
    },
    translate (name, info, total, used) {
      const value = total > 0 ? used / total : 0
      return { name: name, info: info, low: 0.6, high: 0.8, value: value, percent: percent(value), status: statusValue(0.6, 0.8, value) }
    },
    bytes (value) { return bytes(value) }
  },
  mounted () {
    this.stopWatch()
  }
}
</script>
